import { isEmbedUrl } from '../../utils/embed';
import { openPrompt } from '../../utils/prompt';
export const insertEmbedLink = (state, dispatch, view, embedPatterns) => {
  if (dispatch) {
    openPrompt({
      title: 'Create an embeded link',
      fields: [{
        name: 'url',
        label: 'Embeded Url',
        type: 'input',
        required: true,
        rules: [{
          required: true,
          message: 'Please input embeded url'
        }]
      }, {
        name: 'wrapType',
        label: 'Type',
        type: 'select',
        initialValue: 'embed',
        options: [{
          label: 'Inline',
          value: 'inline'
        }, {
          label: 'Embed',
          value: 'embed'
        }]
      }],
      callback(attrs) {
        const {
          url,
          wrapType
        } = attrs;
        const {
          canEmbed,
          width,
          height
        } = isEmbedUrl(url, embedPatterns);
        let embedNode;
        if (!canEmbed || wrapType === 'inline') {
          const {
            link
          } = state.schema.marks;
          embedNode = state.schema.text(url, [link.create({
            href: url
          })]);
        } else {
          embedNode = state.schema.nodes.embedCard.create({
            url: url,
            width,
            height
          });
        }
        const pos = state.tr.selection.from;
        dispatch(state.tr.replaceWith(pos, pos, embedNode));
        view.focus();
      }
    });
  }
  return true;
};